import { useState } from "react";

import { useMatch } from "common/router/hooks";
import { parseNumber } from "common/utils/numbers";

import { Paths } from "client/routes";
import StreamlinedHeader from "client/common/components/header/StreamlinedHeader";
import Page from "client/common/components/layouts/Page";

import AppointmentConfirm from "./AppointmentConfirm";
import AppointmentConfirmSuccess from "./AppointmentConfirmationSuccess";
import { ClientAppointmentWithForms } from "../types";

import styles from "../styles/AppointmentConfirmationPage.module.less";

const AppointmentConfirmationPage = () => {
  const match = useMatch<Paths["scheduler"]["confirm"]>();
  const matchSearch = match.search.appointment_ids ?? "";
  const appointmentIds = matchSearch.split(",").map((id) => parseNumber(id));
  const [confirmedAppointments, setConfirmedAppointments] = useState<
    ClientAppointmentWithForms[] | null
  >(null);

  return (
    <Page Header={<StreamlinedHeader hasPrevious={false} />} Footer={null} className={styles.page}>
      <div className={styles.background} />
      <div className={styles.container}>
        <div className={styles.subcontainer}>
          {confirmedAppointments === null ? (
            <AppointmentConfirm
              appointmentIds={appointmentIds}
              onConfirm={setConfirmedAppointments}
            />
          ) : (
            <AppointmentConfirmSuccess appointments={confirmedAppointments} />
          )}
        </div>
      </div>
    </Page>
  );
};

export default AppointmentConfirmationPage;
